export function createForm(store = null) {
  return {
    id: null,
    baseInfo: {
      mstStore: store,
      title: null,
      sendDate: null,
      hour: null,
      mstMailTemplate: null,
      status: 0,
    },
    condition: {
      page: 0,
      records: 10,
      gender: '0',
      age: null,
      memberNo: null,
      contractProductType: null,
    },
    content: {
      subject: null,
      body: null,
    },
  };
}

export function createFormFromProps(data, htmlToDraftFunction) {
  const { detail, entity } = data;
  return {
    id: detail.id,
    baseInfo: {
      mstStore: detail.mstStoreId
        ? { id: detail.mstStoreId, name: entity.store }
        : null,
      title: detail.title,
      sendDate: detail.sendDate,
      sendHour: detail.sendHour || typeof detail.sendHour === 'number'
        ? { id: detail.sendHour, name: `${detail.sendHour}時` }
        : null,
      mstMailTemplate: null,
      status: detail.mstCodeStatusCode
        ? { id: detail.mstCodeStatusCode, name: entity.status }
        : null,
    },
    condition: {
      page: 0,
      records: 10,
      gender: `${detail.mstCodeGenderCode}`,
      age: detail.mstCodeAgeCode
        ? { id: detail.mstCodeAgeCode, name: entity.age }
        : null,
      memberNo: detail.memberNo ?? null,
      contractProductType: detail.contractProductType || entity.contractProductType
        ? { id: detail.contractProductType, name: entity.contractProductType }
        : null,
    },
    content: {
      subject: detail.subject,
      body: htmlToDraftFunction(detail.body),
    },
  };
}

export function errorMessageForm() {
  return {
    baseInfo: {
      mstStore: '',
      title: '',
      sendAt: '',
      mstMailTemplate: '',
    },
    condition: {
    },
    content: {
      subject: '',
      body: '',
    },
  };
}
